import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(null, {

    [actions.LOAD_LIGHT_STOMPUNKTER_ERROR]: (state, action) => action.error,

    [actions.LOAD_LIGHT_STOMPUNKTER_SUCCESS]: (state, action) => null

})


// WEBPACK FOOTER //
// ./src/reducers/latestLoadLightError.js